import {
  BtnLanguage,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyHyphenList,
  PolicyNumberList,
  PolicySectionTitle,
  PolicyText,
  PolicyTitle,
  PolicyVersion,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ServiceJa = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "ja";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          JA
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li>
              <Link to="/policy/en/service">EN</Link>
            </li>
            <li className="selected">
              <em>JA</em>
            </li>
            <li>
              <Link to="/policy/vi/service">VI</Link>
            </li>
            <li>
              <Link to="/policy/th/service">TH</Link>
            </li>
            <li>
              <Link to="/policy/id/service">ID</Link>
            </li>
            <li>
              <Link to="/policy/es/service">ES</Link>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>

      <PolicyTitle>pregnancy&amp;baby 利用規約</PolicyTitle>

      <PolicyVersion>
        施行日：[2026年9月21日]
        <br />
        最終更新日：[2026年8月25日]
      </PolicyVersion>

      <PolicySectionTitle>
        第1章 pregnancy&amp;babyへようこそ
      </PolicySectionTitle>
      <PolicyText>
        <strong>pregnancy&amp;baby</strong>
        は、妊活、不妊治療、妊娠、出産、産後の回復および育児まで、利用者を幅広くサポートするためのさまざまなサービスを提供します。これらのサービスには、健康・日記記録、パーソナライズされたレポート、情報コンテンツ、コミュニティ機能、その他関連する機能が含まれる場合があります。
      </PolicyText>
      <PolicyText>
        本利用規約（以下「本規約」といいます。）は、株式会社Connecti（以下「当社」といいます。）が提供する
        <strong>pregnancy&amp;baby</strong>
        のモバイルアプリケーション、ウェブサイトおよび関連サービス（以下、総称して「本サービス」といいます。）の利用に適用されます。
      </PolicyText>
      <PolicyText>
        本サービスをご利用になる前に、本規約をよくお読みください。
      </PolicyText>

      <PolicyArticleTitle>第1条 目的および定義</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          本規約は、本規約に同意し会員登録を完了した利用者（以下「会員」といいます。）と当社との間における、本サービスの利用に関する権利、義務、責任、利用条件その他の事項を定めることを目的とします。
        </li>
        <li>
          本規約における用語の定義は、以下のとおりとします。
          <PolicyHyphenList>
            <li>
              「本サービス」とは、当社が提供するpregnancy&amp;babyのモバイルアプリケーション、ウェブサイトおよびこれらに関連するサービスをいいます。
            </li>
            <li>
              「会員」とは、本規約に同意し、本サービスの会員登録を完了した利用者をいいます。
            </li>
            <li>
              「アカウント」とは、会員が本サービスにアクセスし、利用するために使用するアカウントをいいます。
            </li>
            <li>
              「アカウント情報」とは、本サービス内で確認または管理することができる、会員のアカウントに関連する情報をいいます。
            </li>
            <li>
              「コンテンツ」とは、本サービスを通じて提供され、または本サービスに投稿・送信される文章、画像、写真、動画、データ、情報、コメント、投稿その他の資料をいいます。
            </li>
            <li>
              「有料サービス」とは、当社が提供するデジタルコンテンツ、機能、レポートその他のサービスのうち、
              <strong>1回限りの支払い</strong>によって利用できるものをいいます。
            </li>
          </PolicyHyphenList>
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>第2条 本規約の効力および変更</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          本規約は、本サービス内またはその他適切な方法により表示され、会員がこれに同意した時点で効力を生じます。
        </li>
        <li>
          当社は、適用される法令で認められる範囲において、本規約を変更することがあります。
        </li>
        <li>
          本規約を変更する場合、当社は原則として、変更内容および施行日を
          <strong>施行日の15日前まで</strong>に会員へ通知します。
        </li>
        <li>
          変更内容が会員に重大な不利益を与える場合、当社は原則として、
          <strong>施行日の30日前まで</strong>
          に、メール、アプリ内のお知らせ、プッシュ通知その他適切な電子的方法により通知します。
        </li>
        <li>
          適用法令上認められる場合、当社が、所定の期間内に異議を述べない場合は変更後の本規約に同意したものとみなす旨を明確に通知し、会員が当該期間内に異議を述べなかった場合、当該会員は変更後の本規約に同意したものとみなされることがあります。
        </li>
        <li>
          会員が変更後の本規約に同意しない場合、アカウントを削除することにより、本サービスの利用契約を終了することができます。
        </li>
        <li>
          本規約は、原則として会員が本規約に同意した日から本サービスの利用契約が終了するまで適用されます。ただし、その性質上、利用契約終了後も適用されることが予定されている条項は、終了後も効力を有する場合があります。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>第3条 本規約に定めのない事項</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          本規約に定めのない事項については、適用される法令、個別サービスの利用条件および当社が定める運営方針、ガイドライン、規則（以下「運営方針」といいます。）に従います。
        </li>
        <li>
          特定のサービスについて追加の利用条件が適用される場合、そのサービスには当該追加条件が適用されます。
        </li>
        <li>
          本規約の内容と適用法令の強行規定が抵触する場合、当該法令が優先して適用されます。
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>
        第2章 会員登録およびアカウント管理
      </PolicySectionTitle>
      <PolicyArticleTitle>第4条 会員登録</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          利用者が会員登録の際に表示される「同意する」「Accept」「Continue」その他これらに相当するボタンまたはチェックボックスを選択した場合、本規約に同意したものとみなします。
        </li>
        <li>
          本サービスに登録するため、利用者は、当社が定める登録手続に従い、必要な情報を入力し、会員登録手続を完了する必要があります。
        </li>
        <li>
          会員は、当社が対応する以下の方法を利用して、アカウントを作成または本サービスにログインすることができます。
          <PolicyHyphenList>
            <li>メールアドレス</li>
            <li>Google</li>
            <li>Apple</li>
          </PolicyHyphenList>
        </li>
        <li>
          当社は、特定の機能を提供するため、会員を保護するため、適用法令を遵守するため、または本サービスの不正利用を防止するために合理的に必要な場合、追加情報または確認手続を求めることがあります。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        第5条 会員登録の承認、保留および拒否
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          会員登録は、利用者が会員登録を申請し、当社がこれを承認した時点で成立します。
        </li>
        <li>
          当社は、適切に完了した会員登録申請を原則として承認します。ただし、以下の場合、登録の承認を保留、拒否または取消すことがあります。
          <PolicyHyphenList>
            <li>
              他人の氏名、メールアドレス、アカウントその他の情報を権限なく使用した場合
            </li>
            <li>虚偽、不完全または誤解を招く情報を提供した場合</li>
            <li>本サービスを提供するための技術的な容量が十分でない場合</li>
            <li>
              技術上または運営上の問題により本サービスを提供することが困難な場合
            </li>
            <li>
              過去に本サービスの利用停止または制限を受けた者が、別のアカウントを作成して当該制限を回避しようとした場合
            </li>
            <li>会員登録が適用法令、本規約または運営方針に違反する場合</li>
            <li>
              その他、正当な技術上、セキュリティ上、運営上または法的な理由により、登録を承認することができないと当社が合理的に判断した場合
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          登録後に会員が本条に違反して登録したことが判明した場合、当社は状況に応じて、本サービスの利用制限、アカウントの停止または削除等の措置を講じることがあります。
        </li>
      </PolicyNumberList>
      <PolicyArticleTitle>第6条 アカウント管理</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          会員は、自らのアカウントを適切に管理し、第三者による不正利用を防止する責任を負います。
        </li>
        <li>
          会員が自己のアカウントへの不正アクセスまたは不正利用を認識した場合、速やかに合理的なアカウント保護措置を講じ、当社へ通知するものとします。
        </li>
        <li>
          会員は、本サービス内で一部のアカウント情報を確認または変更することができます。ただし、アカウントのセキュリティ、本人識別または技術上の理由により、一部の情報を直接変更できない場合があります。
        </li>
        <li>
          直接変更できない情報を変更する必要がある場合、会員はカスタマーサポートへ問い合わせることができます。
        </li>
        <li>
          Google、Appleによるログインを利用する場合、認証は当該第三者サービスが提供するトークンその他の認証手段を用いて行われます。当社は、これらの第三者サービスが管理するログイン認証情報について、パスワード再設定機能を提供しません。
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>第3章 本サービスの利用</PolicySectionTitle>
      <PolicyArticleTitle>第7条 本サービスの提供</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          会員は、会員登録および利用する機能に必要な手続を完了した後、本サービスを利用することができます。
        </li>
        <li>
          本サービスには、以下の機能等が含まれる場合があります。
          <PolicyHyphenList>
            <li>妊活および生理周期の記録</li>
            <li>排卵検査および妊娠検査の記録・分析</li>
            <li>不妊治療の記録</li>
            <li>妊娠日記および妊娠関連レポート</li>
            <li>胎児の成長レポート</li>
            <li>妊娠中および産後の体重管理</li>
            <li>子どもの成長および発達に関する機能</li>
            <li>子どもの健康および育児に関する記録</li>
            <li>情報ガイドおよびコンテンツ</li>
            <li>コミュニティ機能</li>
            <li>その他当社が提供する機能</li>
          </PolicyHyphenList>
        </li>
        <li>
          一部の機能の利用には、以下が必要となる場合があります。
          <PolicyHyphenList>
            <li>追加情報の入力</li>
            <li>
              健康情報その他の機微な個人情報の取扱いに関する同意を含む、別途の同意
            </li>
            <li>年齢または利用資格に関する要件</li>
            <li>追加の利用条件または方針</li>
            <li>その他、当該機能を提供するために合理的に必要な条件</li>
          </PolicyHyphenList>
        </li>
        <li>
          当社は、本サービスの改善もしくは変更、または機能の追加・削除のため、ソフトウェアのアップデートを提供することがあります。会員には、可能な限り最新バージョンのアプリケーションを利用することを推奨します。
        </li>
        <li>
          当社は、本サービス内に、サービスに関するお知らせ、運営上のメッセージ、情報コンテンツその他の案内を表示することがあります。
        </li>
        <li>
          営利目的またはプロモーション目的のメール、プッシュ通知その他これらに類する連絡は、会員の同意および適用法令に従って送信します。
        </li>
        <li>
          本サービスの利用中にシステムエラーその他の問題を発見した場合、以下のカスタマーサポートまでお問い合わせください。
          <br />
          <a href="mailto:after10month@connect-i.co.kr">
            after10month@connect-i.co.kr
          </a>
        </li>
        <li>
          本サービスの利用に伴い、インターネットサービスプロバイダーまたは携帯通信事業者から課されるデータ通信料その他の通信料金は、会員の負担となります。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        第8条 本サービスの停止、変更および終了
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          当社は、本サービスを継続的かつ安定して提供するため、合理的な努力を行います。
        </li>
        <li>
          法令に別段の定めがない限り、以下の事由がある場合、本サービスの全部または一部を一時的に制限、停止、変更または終了することがあります。
          <PolicyHyphenList>
            <li>システムまたは設備の保守、点検、修理または交換</li>
            <li>停電、設備障害、ネットワーク混雑その他の技術的問題</li>
            <li>第三者サービス提供者との契約の終了または変更</li>
            <li>政府機関による命令、規制または法的要請</li>
            <li>運営、セキュリティまたはサービス方針の変更</li>
            <li>天災、緊急事態、戦争、社会的混乱その他の不可抗力</li>
            <li>その他、本サービスの継続的な提供が著しく困難となる事情</li>
          </PolicyHyphenList>
        </li>
        <li>
          本サービスの重要な停止または終了について、合理的に可能な場合、当社は第21条に定める方法により事前に通知します。
        </li>
        <li>
          サーバー障害、システム障害、セキュリティ事故、外部システムの障害等、予期または制御することが困難な事情により、事前通知を行うことができない場合があります。
        </li>
        <li>
          この場合、当社は可能な限り速やかに本サービスを復旧するため合理的な努力を行います。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>第9条 会員コンテンツの管理</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          会員が投稿したコンテンツが、著作権、プライバシー、知的財産権その他の権利を侵害する場合、権利者は適用法令に従い、当社に対して必要な措置を求めることができます。
        </li>
        <li>
          当社は、コンテンツが以下のいずれかに該当すると合理的に判断した場合、そのコンテンツへのアクセスを制限し、一時的または恒久的に削除することがあります。
          <PolicyHyphenList>
            <li>適用法令に違反する場合</li>
            <li>他人の権利を侵害する場合</li>
            <li>本規約または運営方針に違反する場合</li>
            <li>本サービスのセキュリティまたは正常な運営を脅かす場合</li>
            <li>その他、会員または第三者を保護するための措置が必要な場合</li>
          </PolicyHyphenList>
        </li>
        <li>
          通報、削除その他コンテンツに関する手続については、運営方針において別途定める場合があります。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        第10条 コンテンツの権利帰属および利用
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          会員は、写真、文章、情報、動画、コメント、提案その他のコンテンツを本サービスに投稿することができます。
        </li>
        <li>
          会員が投稿したコンテンツについて会員が有する知的財産権は、引き続き当該会員に帰属します。
        </li>
        <li>
          会員が他の利用者との共有を目的とする本サービス内の領域にコンテンツを投稿する場合、会員は、当該機能の運営、表示、提供および改善に合理的に必要な範囲で、当社が当該コンテンツをホスティング、保存、複製、表示、形式変更および技術的に修正するための非独占的な利用権を当社に許諾します。
        </li>
        <li>
          会員コンテンツは、投稿先の機能の性質に応じて、検索結果、フィード、パーソナライズされたコンテンツ領域その他本サービス内の場所に表示される場合があります。
        </li>
        <li>
          当社は、会員コンテンツが以下のいずれかに該当すると合理的に判断した場合、事前通知なく投稿を拒否し、利用を制限し、または削除することがあります。
          <PolicyHyphenList>
            <li>違法なコンテンツ</li>
            <li>わいせつまたは性的搾取に関連するコンテンツ</li>
            <li>憎悪、違法な差別または暴力を助長するコンテンツ</li>
            <li>スパムまたは許可されていない広告</li>
            <li>他人になりすますコンテンツ</li>
            <li>第三者の権利を侵害するコンテンツ</li>
            <li>詐欺的または誤解を招くコンテンツ</li>
            <li>その他、本規約または運営方針に違反するコンテンツ</li>
          </PolicyHyphenList>
        </li>
        <li>
          当社は、すべての会員コンテンツを事前に確認する義務を負いません。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>第11条 利用上の禁止事項</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          会員は、本サービスの利用にあたり、以下の行為を行ってはなりません。
          <PolicyHyphenList>
            <li>
              虚偽の情報を提供し、または他人のアカウントもしくは身元を不正に利用する行為
            </li>
            <li>
              適用法令により明示的に認められる場合を除き、当社の許可なく、本サービスを複製、変更、配布、販売、譲渡、貸与し、リバースエンジニアリング、逆コンパイルを行い、またはソースコードの抽出を試みる行為
            </li>
            <li>
              他人を誹謗中傷、脅迫、嫌がらせし、またはその他の方法で害する行為
            </li>
            <li>違法、わいせつ、搾取的その他禁止された資料を投稿する行為</li>
            <li>
              当社または第三者の著作権、商標権、プライバシー権その他の権利を侵害する行為
            </li>
            <li>
              当社または他人について虚偽または誤解を招く情報を公開する行為
            </li>
            <li>適用法令または公序良俗に反するコンテンツを配布する行為</li>
            <li>
              マルウェア、ウイルス、悪意あるコードその他本サービスを損傷または妨害することを目的とするものを導入する行為
            </li>
            <li>本サービスの正常な運営を故意に妨害する行為</li>
            <li>
              他人になりすまし、または他人もしくは団体との関係を虚偽表示する行為
            </li>
            <li>
              適切な権限なく、他の会員の個人情報を収集、保存または公開する行為
            </li>
            <li>
              財産上の利益を得る目的または他人に損害を与える目的で不正な情報を配布する行為
            </li>
            <li>違法な賭博その他の違法行為</li>
            <li>違法な性的サービスまたは搾取的行為を勧誘または仲介する行為</li>
            <li>
              相手方に恐怖、屈辱、嫌がらせまたは重大な精神的苦痛を与える目的でコンテンツを繰り返し送信する行為
            </li>
            <li>適用法令により禁止された情報を送信または公開する行為</li>
            <li>
              当社の従業員、サービス運営者または事業パートナーになりすます行為
            </li>
            <li>虚偽または悪意ある通報により通報制度を濫用する行為</li>
            <li>
              ストーキング、暴言その他の方法により、他の会員による本サービスの利用を妨げる行為
            </li>
            <li>その他、適用法令、本規約または運営方針に違反する行為</li>
          </PolicyHyphenList>
        </li>
        <li>
          一部のサービスについては、年齢、利用資格、居住地域その他の法的要件に基づき利用が制限される場合があります。
        </li>
        <li>
          会員が本条に違反した場合、当社は当該行為を調査し、コンテンツの削除、特定機能の一時的または恒久的な利用制限、アカウントの停止または利用契約の終了等の措置を講じることがあります。
        </li>
        <li>
          重大な違法行為、他人への重大な損害、安全への脅威、セキュリティ上のリスクまたは繰り返しの違反がある場合、当社は直ちにより厳格な措置を講じることがあります。
        </li>
        <li>
          会員は、当社による利用制限について、カスタマーサポートを通じて再検討を求めることができます。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>第12条 利用契約の終了</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          会員がアカウントを削除した場合、会員と当社との間の本サービス利用契約も終了します。
        </li>
        <li>
          会員は、本サービス内のアカウント削除機能またはカスタマーサポートを通じて、いつでもアカウントの削除を申請することができます。
        </li>
        <li>
          利用契約終了時の会員情報およびサービスデータは、適用法令および
          <strong>pregnancy&amp;babyプライバシーポリシー</strong>
          に従って取り扱われます。
        </li>
        <li>
          会員を識別できる個人情報は、プライバシーポリシーに従って削除されます。ただし、適用法令により保存が要求または許容される場合を除きます。
        </li>
        <li>
          一部のサービスデータについては、プライバシーポリシーに記載するとおり、不可逆的に匿名化した上で、研究、統計、分析およびサービス改善の目的で保有される場合があります。
        </li>
        <li>
          コミュニティの投稿やコメント等、会員が公開または他の会員と共有したコンテンツについては、他の会員の会話、やり取りまたは共有領域の一部となっている場合、アカウント削除時に自動的に削除されないことがあります。
        </li>
        <li>
          会員は、削除を希望するコンテンツがある場合、アカウント削除前に自ら削除することを推奨します。アカウント削除後もコンテンツが残る場合、ニックネーム等のアカウントを識別する情報については、適切に削除または切り離す場合があります。
        </li>
        <li>
          Google、Apple等の第三者ログインサービスを利用している会員が、当該第三者アカウントを削除またはpregnancy&amp;babyとの連携を解除した場合、そのログイン方法では本サービスへアクセスできなくなることがあります。
        </li>
        <li>
          アカウント削除に伴い削除されたデータは、原則として復元することができません。
        </li>
        <li>
          退会後も再度アカウント作成を申し込むことができます。ただし、過去に適用法令、本規約または運営方針に違反したことにより再登録が制限される場合を除きます。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>第13条 個人情報の保護</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          当社は、本サービスの提供に必要な範囲で個人情報を取り扱い、適用されるプライバシーおよび個人情報保護法令を遵守します。
        </li>
        <li>
          個人情報は、当社のプライバシーポリシー、関連する同意文書その他法令上必要な通知に記載された目的および範囲内でのみ取り扱います。
        </li>
        <li>
          特定の機能において健康情報その他の機微な個人情報を取り扱う必要がある場合、当社は適用法令により必要とされる同意を取得します。
        </li>
        <li>
          当社は、以下の場合を除き、独立した第三者に個人情報を提供しません。
          <PolicyHyphenList>
            <li>会員が同意した場合</li>
            <li>プライバシーポリシーに記載されている場合</li>
            <li>
              当社に代わって個人情報を取り扱うサービス提供者に提供する場合
            </li>
            <li>適用法令上要求または許容される場合</li>
            <li>その他法的に認められる場合</li>
          </PolicyHyphenList>
        </li>
        <li>
          当社による個人情報の取得、利用、共有、保有、国外移転および保護に関する詳細は、
          <strong>pregnancy&amp;babyプライバシーポリシー</strong>
          をご確認ください。
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>第4章 有料サービス</PolicySectionTitle>
      <PolicyArticleTitle>第14条 有料サービスに関する情報</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          当社が有料サービスを提供する場合、会員は、当該有料サービスについて表示された条件に従い、
          <strong>1回限りの利用料金</strong>
          を支払うことで利用することができます。
        </li>
        <li>
          購入完了前に、当社または該当するアプリストアは、以下の主要情報を合理的に確認できるようにします。
          <PolicyHyphenList>
            <li>有料サービスの名称または説明</li>
            <li>有料サービスの提供者</li>
            <li>有料サービスの内容および主要な機能</li>
            <li>利用料金</li>
            <li>その他、適用法令上必要な重要な購入条件</li>
          </PolicyHyphenList>
        </li>
        <li>
          有料サービスを利用できるかどうかは、利用者の端末、OS、国、アプリストアおよびその他の技術的条件により異なる場合があります。
        </li>
        <li>
          別途明示される場合を除き、有料サービスは
          <strong>
            1回限りの購入であり、自動更新または継続的な課金は行われません
          </strong>
          。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>第15条 有料サービス利用契約の成立</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          会員は、当社または該当するアプリストアが提供する購入手続を通じて、有料サービスを購入することができます。
        </li>
        <li>
          購入手続には、以下が含まれる場合があります。
          <PolicyHyphenList>
            <li>有料サービスの確認および選択</li>
            <li>価格および重要な利用条件の確認</li>
            <li>利用可能な支払方法の選択</li>
            <li>購入内容の確認</li>
            <li>支払完了</li>
          </PolicyHyphenList>
        </li>
        <li>
          有料サービス利用契約は、購入手続が正常に完了し、購入完了表示その他これに相当する確認が行われた時点で成立します。
        </li>
        <li>
          以下の場合、当社は取引を拒否、取消しまたは保留することがあります。
          <PolicyHyphenList>
            <li>虚偽または権限のない情報が使用された場合</li>
            <li>支払方法について正当な利用権限がない場合</li>
            <li>会員が当該取引を行う法的資格を有していない場合</li>
            <li>技術上または運営上の問題により購入を完了できない場合</li>
            <li>会員のアカウントが停止または利用制限されている場合</li>
            <li>
              当該取引が適用法令、本規約またはアプリストアのポリシーに違反する場合
            </li>
          </PolicyHyphenList>
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>第16条 有料サービスの支払い</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          利用可能な支払方法は、国、端末、プラットフォームおよび該当するアプリストアまたは決済事業者が対応する方法により異なる場合があります。
        </li>
        <li>
          モバイルアプリケーションを通じて有料サービスを購入する場合、以下のアプリストアを通じた1回限りのアプリ内課金（In-App
          Purchase）により支払われる場合があります。
          <PolicyHyphenList>
            <li>Apple App Store</li>
            <li>Google Play</li>
          </PolicyHyphenList>
        </li>
        <li>
          アプリストアを通じて行われる支払いについては、当該アプリストアの支払条件、請求ルール、キャンセル手続、返金ポリシーその他の関連規定が適用されます。
        </li>
        <li>
          会員は、自らが正当に利用する権限を有する支払方法のみを使用するものとします。
        </li>
        <li>
          会員は、支払いに関連して入力する情報が正確であり、適法に利用できるものであることを確認する責任を負います。
        </li>
        <li>
          決済事業者またはアプリストアは、取引上限、地域制限、年齢要件その他の条件を設定する場合があります。
        </li>
        <li>
          支払いがアプリストアまたは独立した決済事業者によって全面的に処理される場合、当社はクレジットカード番号等の完全なカード情報を保存しません。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        第17条 有料サービスのキャンセルおよび撤回
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          有料サービスの購入キャンセル、申込みの撤回または返金の可否については、以下の事項に基づいて判断されます。
          <PolicyHyphenList>
            <li>適用される消費者保護法令</li>
            <li>当該有料サービスの性質</li>
            <li>当該有料サービスがすでに提供または利用されているかどうか</li>
            <li>購入時に表示された利用条件</li>
            <li>
              アプリストアを通じて購入した場合、当該アプリストアのポリシー
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Apple App StoreまたはGoogle
          Playを通じて購入した場合、キャンセル、撤回または返金の申請について、当該アプリストアのポリシーに従い、利用者自身が当該アプリストアを通じて手続を行う必要がある場合があります。
        </li>
        <li>
          適用法令上認められ、法令上必要な通知または同意手続が行われている場合、すでに提供または利用が開始された一部のデジタルコンテンツまたはサービスについては、撤回または返金が制限されることがあります。
        </li>
        <li>
          適用法令により会員に強行的に保障されるキャンセル、撤回または返金の権利は、本規約によって制限されません。
        </li>
        <li>
          返金対象となった購入に付随して提供された特典、クーポンその他の付加的な利益については、適用法令で認められる範囲で取り消し、または利用を制限する場合があります。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>第18条 有料サービスの利用制限</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          当社は、正常に購入された有料サービスを、当該サービスに表示された条件に従って利用できるよう提供します。
        </li>
        <li>
          会員が以下に該当する場合、当社は適用法令で認められる範囲において、有料サービスへのアクセスを制限または停止することがあります。
          <PolicyHyphenList>
            <li>本規約に違反した場合</li>
            <li>詐欺または違法行為を行った場合</li>
            <li>権限のない支払方法を利用した場合</li>
            <li>返金または決済システムを不正に利用した場合</li>
            <li>その他、適用法令上利用制限を行う合理的な理由がある場合</li>
          </PolicyHyphenList>
        </li>
        <li>
          必要に応じて、会員はカスタマーサポートを通じて当該利用制限の再検討を求めることができます。
        </li>
        <li>
          有料サービスの利用制限は、別途明示される場合を除き、会員のpregnancy&amp;babyアカウント自体を終了するものではありません。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>第19条 返金</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          返金の可否および返金額は、適用法令、有料サービスの種類、サービスまたはデジタルコンテンツがすでに提供・利用されているかどうか、および購入時に表示されたポリシー等によって異なります。
        </li>
        <li>
          <strong>
            Apple App StoreまたはGoogle Playを通じて支払いが行われた場合、
          </strong>
          原則として当該アプリストアの返金ポリシーおよび手続が適用され、当社が直接返金を行うことができない場合があります。
        </li>
        <li>
          適用法令上認められ、必要な通知または同意手続が行われている場合、すでに提供または利用が開始された一部のデジタルコンテンツまたはサービスについては、返金が制限される場合があります。
        </li>
        <li>
          特定の有料サービスについて別途の返金ポリシーが適用される場合、当社は購入手続中に当該ポリシーを表示します。
        </li>
        <li>
          本条のいかなる規定も、会員に適用される法令に基づき制限または排除することのできない返金、キャンセル、撤回その他の消費者の権利を制限するものではありません。
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>第5章 その他</PolicySectionTitle>
      <PolicyArticleTitle>第20条 免責および責任</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          当社は、適用法令上許容される最大限の範囲において、本規約に明示的に定められていない事項について、保証を行いません。
        </li>
        <li>
          当社は、以下の情報源から提供される情報について、その完全性、正確性、信頼性または特定目的への適合性を保証しません。
          <PolicyHyphenList>
            <li>会員</li>
            <li>第三者コンテンツ提供者</li>
            <li>公的データベース</li>
            <li>外部サービス</li>
            <li>その他独立した情報源</li>
          </PolicyHyphenList>
        </li>
        <li>
          生理周期の予測、妊娠しやすい時期の推定、妊娠に関する計算、胎児の成長分析、子どもの成長・発達情報その他の健康関連機能を含む本サービスは、
          <strong>情報提供および利用者を支援する目的</strong>で提供されます。
        </li>
        <li>
          本サービスは、医師その他の医療専門家による診断、検査、治療または医学的助言に代わるものではなく、そのような目的を意図するものでもありません。
        </li>
        <li>
          当社の故意または過失により会員に損害が生じた場合、当社は適用法令に従って責任を負います。
        </li>
        <li>
          適用法令で認められる範囲において、当社は、当社の故意または過失によらない損害、特に以下の事由のみにより生じた損害について責任を負いません。
          <PolicyHyphenList>
            <li>不可抗力または当社の合理的な支配を超える事情</li>
            <li>会員自身の作為または不作為</li>
            <li>
              当社が合理的に防止することのできなかった第三者による不正アクセスまたは攻撃
            </li>
            <li>第三者が導入したマルウェアまたは悪意のあるソフトウェア</li>
            <li>
              当社の合理的な支配を超える第三者のネットワーク、システムまたはサービスの障害
            </li>
            <li>その他、当社の故意または過失によらない事情</li>
          </PolicyHyphenList>
        </li>
        <li>
          適用法令で認められる範囲において、当社が法的責任を負うべき場合を除き、会員間または会員と独立した第三者との間で生じた紛争について、当社は責任を負いません。
        </li>
        <li>
          本規約のいかなる内容も、適用される消費者保護法その他の強行法規に基づき制限または排除することのできない責任を制限または排除するものではありません。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>第21条 通知および連絡</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          会員は、本サービスに関する事項について、いつでもカスタマーサポートを通じて当社へ問い合わせることができます。
        </li>
        <li>
          会員全体に対する一般的なお知らせは、本サービス内のお知らせとして7日以上掲載する方法その他合理的な方法により行うことがあります。
        </li>
        <li>
          会員の権利または本サービスの利用に重大な影響を及ぼす事項については、以下の方法等により個別に通知する場合があります。
          <PolicyHyphenList>
            <li>メール</li>
            <li>プッシュ通知</li>
            <li>アプリ内メッセージ</li>
            <li>その他適切な電子的方法</li>
          </PolicyHyphenList>
        </li>
        <li>
          会員が当該連絡方法を利用するために必要な情報を提供していない場合、当社はその方法による通知を行う義務を負いません。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>第22条 準拠法および紛争解決</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          本規約および当社と会員との関係は、原則として
          <strong>大韓民国の法律</strong>
          に準拠します。ただし、会員の居住国または地域の法令により強行的に適用される消費者保護規定その他の権利を妨げるものではありません。
        </li>
        <li>
          本サービスに関連して当社と会員との間に紛争が生じた場合、当社および会員は、まず誠実な協議による解決に向けて合理的な努力を行います。
        </li>
        <li>
          協議によって紛争を解決できない場合、適用法令上管轄を有する裁判所に提起することができます。
        </li>
        <li>
          本規約のいかなる内容も、会員の居住国または地域の強行法規により保障される裁判所または権限ある機関に対する申立ての権利を奪うものではありません。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>第23条 その他</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          本規約に明示されていない事項については、適用法令および法令上認められる範囲で一般に認められた慣行に従います。
        </li>
        <li>
          本規約の一部の条項が無効、違法または執行不能と判断された場合でも、その他の条項は、法令上認められる最大限の範囲で引き続き有効とします。
        </li>
        <li>
          当社が本規約のいずれかの条項を行使しなかった場合でも、当該条項またはその他の権利を放棄したものとはみなされません。
        </li>
        <li>
          本規約の見出しは便宜上設けられたものであり、本規約の解釈に影響を与えるものではありません。
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>附則</PolicyArticleTitle>
      <PolicyText>
        本規約は、<strong>[2026年9月21日]</strong>から施行します。
      </PolicyText>
      <PolicyText>
        本規約の公表後、記載された施行日前に新たに会員登録を行った会員については、適用法令で認められる範囲において、会員登録日から本規約を適用する場合があります。
      </PolicyText>
    </PolicyContainer>
  );
};

export default ServiceJa;
